import {FC, memo, useMemo} from "react";
import {IDataGridColumnEditorSelect} from "../../../model";
import {Controller, useForm} from "react-hook-form";
import {ClickAwayListener} from "@material-ui/core";
import Select from "../../../../form/select";
import Footer from "./footer";
import {validateRule} from "../../../../form/heplers";

const EditorSelect: FC<{
  editor: IDataGridColumnEditorSelect,
  data: string | number,
  onClose: any,
  onSubmit: any
}> = ({editor, data, onClose, onSubmit}) => {
  const {handleSubmit, errors, control} = useForm({defaultValues: {data: data || ''}});
  const settings = useMemo(() => ({
    placeholder: '',
    clearable: !editor.required,
    multiple: false,
    ...editor
  }), [editor]);
  return (
    <ClickAwayListener onClickAway={onClose}>
      <div className="grid-editor string">
        <form
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            as={
              <Select
                // @ts-ignore
                settings={settings}
                error={errors.data}
              />
            }
            name="data"
            control={control}
            rules={editor.required ? validateRule('required') : {}}
          />
          <Footer onClose={onClose}/>
        </form>
      </div>
    </ClickAwayListener>
  )
};

export default memo(EditorSelect)
